import { type Scalars } from '../__generated-gql-types__/globalTypes';

import mxpnl from './analytics/mixpanel';
import phog from './analytics/posthog/posthog';
export const trackFirstMessageSent = (props: {
  coachUrn: Scalars['CoachUrn']['output'];
}) => {
  mxpnl.track('firstMessageSent', {
    ...props,
  });
  phog.capture('first_message_send', {
    ...props,
  });
};
